// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"53":"e2cd7e60","422":"e47a10e1","894":"aa9b0f21"}[chunkId] + ".chunk.js");